<template>
  <html>

  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
    <meta name="mobile-web-app-capable" content="yes" />
    <meta name="apple-mobile-web-app-capable" content="yes" />
    <link rel="icon" type="image/png" href="favicon.png" />
    <title>Restó APP</title>
  </head>

  <body class="home-page">
    <Header :isRestoCompleto="this.pasosCompletados == 8?true:false"/>
    <div class="col-lg-8 mx-auto p-3 py-md-5">
      <main>
        <h2>Eliminación de cuenta</h2>
        <hr class="" />
        <h3>Al eliminar su cuenta se desactivaran todas las reservas que tiene pendientes. Esta acción no se puede deshacer</h3>

        <div class="col-sm-12"><button type="button"  class="btn btn-primary" 
          @click="showEliminar=true" 
          >Eliminar Cuenta</button>
              
        </div>
        <PopUpConfirmacionHtmlEspera :show="showEliminar" @close="showEliminar = false" @confirmar="eliminarCuenta();confirmacion_estado_html = false;">
          <template #body>
            <p>¿Seguro que desea eliminar su cuenta? Esta acción no es reversible y cancelará todas las reservas que tenga pendiente</p>
          </template>
        </PopUpConfirmacionHtmlEspera>
        <PopUp :show="show_mensaje" @close="show_mensaje = false; goToPage('login');">
          <template #body>
            <p>{{ msg }}</p>
          </template>
        </PopUp>
      </main>
      <Footer />
    </div>
  </body>

  </html>
</template>

<script>


import "vue2-datepicker/index.css";
import axios from "axios";
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import PopUpConfirmacionHtmlEspera from "../components/PopUpConfirmacionHtmlEspera.vue";
import PopUp from "../components/PopUp.vue";
export default {
  name: "MiPerfil",
  components: { Header, Footer ,PopUpConfirmacionHtmlEspera, PopUp },
  data: function () {
    return {
      showEliminar: false,
      show_mensaje: false,
      msg: ""
    };
  },
  methods: {
      eliminarCuenta() {
        this.showEliminar = false
        axios
        .post("/eliminarRestaurante")
        .then(() => {
          this.show_mensaje = true;
          this.msg = "Cuenta Eliminada con exito"
          localStorage.token="";
        }, () => {
          this.show_mensaje = true;
          this.msg = "Ocurrió un error al intentar eliminar la cuenta. Por favor intente nuevamente mas tarde"
        });
      },
      goToPage(page) {
        this.$router.push({ name: page });
        if (page.startsWith('Perfil') || page.startsWith('Infraestructura') || page.startsWith('Servicios') || page.startsWith('Especialidades') || page.startsWith('RegistrarMesa') || page.startsWith('Horarios') || page.startsWith('Imagenes') || page.startsWith('ImagenesMenu')) {
          this.children.visible = true;
        }
      }
  },

  beforeMount() {
    axios
      .get("/getUsuario")
      .then((data) => {
        console.log(data)
        if (data.status == 200) {
          this.usuario_id = data.data.usuario_id;
          this.email=data.data.mail;
          this.nombre=data.data.nombre;
          this.apellido=data.data.apellido;
          this.telefono=data.data.telefono;
        }
      })
      .catch((w) => {
        console.log(w);
        this.error = true;
        this.error_msg =
          "No se ha podido actualizar la informacion. Vuelva a intentar mas tarde";
      });
    
  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:host {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}

body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
</style>
